// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"7cd67ff884e9b2be994c","740":"4dd04c2caef01a96513c"}[chunkId] + ".css";
};